module.exports = __webpack_public_path__ + "assets/img/map.eece6250.png";